import React, { FC } from 'react';
import { OzoneDesign } from 'components/pages/ozone-design';
import { useUser } from 'hooks/use-user';
import { NotFound } from '../404';

const allowed_emails = ['arun@rocketlane.com', 'sudarsan@rocketlane.com'];

export const Ozone: FC = () => {
  const { user } = useUser();
  const enable = allowed_emails.includes(user?.emailId);

  return enable ? <OzoneDesign /> : <NotFound />;
};
